const LOGO_URL = "https://customer-assets.emergentagent.com/job_e67a0971-45d9-4d0f-b06b-f0d31f74177c/artifacts/0mpqvdtb_IMG_5829.jpeg";

/**
 * MJLogo — renders the crimson MJ emblem as a perfect circle,
 * cropping out the white JPEG background via background-size trick.
 *
 * @param {number} size  — diameter in px (default 48)
 * @param {string} className — extra tailwind classes
 */
export default function MJLogo({ size = 48, className = '' }) {
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        minWidth: size,
        borderRadius: '50%',
        backgroundImage: `url(${LOGO_URL})`,
        backgroundSize: '118%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    />
  );
}
